import {
    PricePage,
    Dashboard,
    Registration,
    SettingsComponent,
    RouteManagementPage,
    RecoveryPassword,
    PageNotFound,
    OffersForm,
    ServicePage,
    HelpForm,
    LogPage,
    LogsListPage,
    JsonValidatorPage,
    JwtDebuggerPage,
    Base64Page,
    UrlEncoderPage,
    UuidGeneratorPage,
    ToolsHubPage,
    ConnectPage,
} from "@src/pages";
import {Login} from "@src/pages/login-page";
import type {FC} from "react";
import {Route, Routes} from "react-router-dom";
import {APP_ROUTES} from "../constants";
import {ErrorLayout, FullLayout, Layout} from "../layout";
import {ChangePasswordForm} from "@src/pages/change-password-form";

export const Router: FC = () => {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <FullLayout>
                        <PricePage/>
                    </FullLayout>
                }
            />
            <Route
                path={`${APP_ROUTES.DASHBOARD}`}
                element={
                    <FullLayout>
                        <Dashboard/>
                    </FullLayout>
                }
            />
            <Route
                path={`${APP_ROUTES.DOCUMENTATION}`}
                element={
                    <FullLayout>
                        <ServicePage/>
                    </FullLayout>
                }
            />
            <Route
                path={`${APP_ROUTES.LOGIN}`}
                element={
                    <Layout>
                        <Login/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.REGISTRATION}`}
                element={
                    <Layout>
                        <Registration/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.SETTINGS}`}
                element={
                    <Layout>
                        <SettingsComponent/>{" "}
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.RECOVERY_PASSWORD}`}
                element={
                    <Layout>
                        <RecoveryPassword/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.WORKSPACE}`}
                element={
                    <Layout>
                        <RouteManagementPage/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.WORKSPACE}/create`}
                element={
                    <Layout>
                        <RouteManagementPage/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.WORKSPACE}/update/:workspaceId`}
                element={
                    <Layout>
                        <RouteManagementPage/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.WORKSPACE}/:workspaceId${APP_ROUTES.ROUTES}/create`}
                element={
                    <Layout>
                        <RouteManagementPage/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.WORKSPACE}/:workspaceId`}
                element={
                    <Layout>
                        <RouteManagementPage/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.WORKSPACE}/:workspaceId${APP_ROUTES.ROUTES}/update/:routeId`}
                element={
                    <Layout>
                        <RouteManagementPage/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.WORKSPACE}/:workspaceId${APP_ROUTES.ROUTES}`}
                element={
                    <Layout>
                        <RouteManagementPage/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.LOGS}`}
                element={
                    <Layout>
                        <LogsListPage/>
                    </Layout>
                }
            />
            <Route
                path={`${APP_ROUTES.LOG}/:logId`}
                element={
                    <Layout>
                        <LogPage/>
                    </Layout>
                }
            />
            <Route
                path={APP_ROUTES.OFFER}
                element={
                    <FullLayout>
                        <OffersForm/>
                    </FullLayout>
                }
            />
            <Route
                path={APP_ROUTES.HELP}
                element={
                    <FullLayout>
                        <HelpForm/>
                    </FullLayout>
                }
            />
            <Route
                path={APP_ROUTES.CHANGE_PASSWORD}
                element={
                    <FullLayout>
                        <ChangePasswordForm/>
                    </FullLayout>
                }
            />
            <Route
                path={APP_ROUTES.JSON_VALIDATOR}
                element={
                    <FullLayout>
                        <JsonValidatorPage/>
                    </FullLayout>
                }
            />
            <Route
                path={APP_ROUTES.TOOLS}
                element={
                    <FullLayout>
                        <ToolsHubPage/>
                    </FullLayout>
                }
            />
            <Route
                path={APP_ROUTES.JWT_DEBUGGER}
                element={
                    <FullLayout>
                        <JwtDebuggerPage/>
                    </FullLayout>
                }
            />
            <Route
                path={APP_ROUTES.BASE64}
                element={
                    <FullLayout>
                        <Base64Page/>
                    </FullLayout>
                }
            />
            <Route
                path={APP_ROUTES.URL_ENCODER}
                element={
                    <FullLayout>
                        <UrlEncoderPage/>
                    </FullLayout>
                }
            />
            <Route
                path={APP_ROUTES.UUID_GENERATOR}
                element={
                    <FullLayout>
                        <UuidGeneratorPage/>
                    </FullLayout>
                }
            />
            <Route
                path={APP_ROUTES.CONNECT}
                element={
                    <Layout>
                        <ConnectPage/>
                    </Layout>
                }
            />
            <Route
                path="*"
                element={
                    <ErrorLayout>
                        <PageNotFound/>
                    </ErrorLayout>
                }
            />
        </Routes>
    );
};
